export default __webpack_public_path__ + "static/media/CreditCardBlack.9438cc2e.svg";